import { connect, type ConnectedProps } from 'react-redux';

import { fetchHotelImagesAction } from 'src/store/hotelImages/sagaActions';
import {
  resetPopupData,
  setPopupData,
  toggleMap,
} from '../../../../domain/state/map/actions';

import { getBrowser } from '../../../../domain/state/browser/selectors';
import { getHasHotels } from '../../../../domain/state/hotels/selectors';
import {
  getMapProps,
  popupDataSelector,
} from '../../../../domain/state/map/selectors';

import { Map } from './Map';

const mapStateToProps = (state) => ({
  mapProps: getMapProps(state),
  browser: getBrowser(state),
  hasHotel: getHasHotels(state),
  hotelInfo: popupDataSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  onToggleMap: () => dispatch(toggleMap()),
  getImages: (hotelId) => dispatch(fetchHotelImagesAction(hotelId)),
  setPopup: (hotelInfo) => dispatch(setPopupData(hotelInfo)),
  resetPopup: () => dispatch(resetPopupData()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(Map);
